require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-what-should-mdbs-do-to-improve-their-role-as-catalyzers.json") })
        }
      }, "path---en-us-update-what-should-mdbs-do-to-improve-their-role-as-catalyzers");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-what-should-mdbs-do-to-improve-their-role-as-catalyzers!./.cache/json/en-us-update-what-should-mdbs-do-to-improve-their-role-as-catalyzers.json
// module id = 850
// module chunks = 231608221292675